import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
const Contact = () => {
  const { t } = useTranslation();
  return (
    <div className="section" id="contact">
      <div className="text-center max-w-[600px] mx-auto">
        <div className="sm:text-3xl text-2xl font-bold mb-5">
        {t("subscribe_newsletter")}
        </div>
        <p className="text-sm leading-7 text-gray">
        {t("subscribe_newsletter_text")}
        </p>
        <motion.form
          initial={{ scale: 0 }}
          whileInView={{ scale: 1 }}
          transition={{ duration: 0.3 }}
          className="mt-5"
        >
          <input
            type="text"
            placeholder={t("enter_email")}
            className="sm:p-3 p-2 outline-none text-sm shadow-md sm:w-72 w-60"
          />
          <button className="text-sm text-white bg-Teal sm:p-3 p-2 shadow-md font-bold">
          {t("subscribe")}
          </button>
        </motion.form>
      </div>
    </div>
  );
};

export default Contact;
